import {createReducer, on} from '@ngrx/store';
import { ExportRequestsActions } from './export-requests.actions';
import {TableSummary} from 'daisy-design-system-front';

export const exportRequestsFeatureKey = 'Reporting-export-requests';

export type ExportRequestsState =
  | {
      loading: true;
    }
  | ({ loading: false } & (
      | {
          hasError: true;
          errorMessage: string;
        }
      | {
          hasError: false;
          tableSummary: TableSummary;
          totalItems: number;
        }
    ));

export const initialExportRequests: ExportRequestsState = {
    loading: true,
};

export const exportRequestsReducer = createReducer<ExportRequestsState>(
    initialExportRequests as ExportRequestsState,
    on(
        ExportRequestsActions.fetchSuccess,
        (_, { response }): ExportRequestsState => ({
            loading: false,
            hasError: false,
            tableSummary: {rows: response.list?.map(item => ({...item})) },
            totalItems: response.paging.totalItems,
        })
    ),

    on(ExportRequestsActions.fetchFailure,
        (_, {message}) => ({
            loading: false,
            hasError: true,
            errorMessage: message,
        })
    ),
    on(ExportRequestsActions.updateActive,
        (state, { active, uid }): ExportRequestsState => {
          if (state.loading === false && state.hasError === false) {
            const newRows = state.tableSummary.rows.map((row: any) =>
              row.id === uid ? { ...row, active } : row
            );

            return {
              ...state,
              tableSummary: {
                ...state.tableSummary,
                rows: newRows
              }
            };
          }

          return { ...state };
        }
      )

);
